import React, { useState } from "react";
import { Grid2, Typography, Card, Button } from "@mui/material";
import Loading from "../Layout/Loading";

const CoachingSignUpCreateAccountLink = () => {
  useEffect(() => {
    window.location.href = `/clients`;
  }, []);

  return (
    <Grid2 container justifyContent="center" sx={{ m: 4 }}>
      <Loading />
    </Grid2>
  );
};

export default CoachingSignUpCreateAccountLink;
